import React from 'react'
import { graphql } from 'gatsby'

import Buy from '~containers/Buy'
import PropTypes from 'prop-types'

const BuyPage = () => {
  return <Buy />
}

export const query = graphql`
  query ($language: String!) {
    landingJson {
      landingData {
        answer
        question
      }
    }
    locales: allLocale(
      filter: {
        ns: { in: ["common", "landing", "footer", "faqs"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
BuyPage.defaultProps = {
  data: {
    landingJson: {
      landingData: [],
    },
  },
}
BuyPage.propTypes = {
  data: PropTypes.shape({
    landingJson: PropTypes.shape({
      landingData: PropTypes.arrayOf(
        PropTypes.shape({
          question: PropTypes.string,
          answer: PropTypes.string,
        })
      ),
    }),
  }),
}

export default BuyPage
